<template></template>

<script>
import { EventBus } from "@/main";

// Class
import SalesOrder from "@/clas/SalesOrder";

export default {
	data() {
		return {};
	},

	mounted() {
		this.start();
	},

	methods: {
		async start() {
			try {
				const notification = new Audio(
					"https://apps.pinturasacuario.mx/assets/audios/notification.mp3"
				);

				await new Promise((resolve) => setTimeout(resolve, 15000));

				const last = await new SalesOrder().last();

				if (this.$store.state.sales_order_last_id) {
					let diff = last.id - this.$store.state.sales_order_last_id;

					if (diff > 0) {
						notification.play();

						EventBus.$emit("SalesOrderGet");

						Push.create("Pedidos Pinturas Acuario", {
							body:
								diff > 1
									? `${diff} pedidos nuevos.`
									: "1 pedido nuevo.",
							icon:
								"https://apps.pinturasacuario.mx/assets/logo-acuario-color-A.png",
							timeout: 7000,
							onClick: function() {
								window.focus();
								this.close();
							},
						});
					}
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.start();
			}
		},

		// async start() {
		// 	try {
		// 		await firebaseMessaging.requestPermission();

		// 		let token = await firebaseMessaging.getToken({
		// 			vapidKey:
		// 				"BET1NC_ojy4hCp0zoxfU29w8co2EF4oDkSBCiOWM4qcxiG3WmfaubqSzNy_KhK-XCsF5bO_94hgELQNVaeqg3HM",
		// 		});

		// 		console.log(token);
		// 	} catch (error) {
		// 		EventBus.$emit("Error", { error: error, errorsShow: true });
		// 	}
		// },
	},
};
</script>

<style lang="css" scoped></style>
